export const chipClassName = `
    w-full
    p-2
    rounded-xl
    text-xs
    text-black-400
`
